import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../../services/adminApi';

const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/admin" replace />;
};

export default PrivateRoute;
